import { Avatar, Box, IconButton, Typography } from "@mui/material";
import React from "react";
import { motion } from "framer-motion";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import { Instagram } from "@mui/icons-material";
import { FacebookIcon } from "lucide-react";
import X from "@mui/icons-material/X";
import { FaWhatsapp } from "react-icons/fa";

const MotionTypography = motion(Typography);

function AboutUs() {
  return (
    <Box sx={{ p: 4, backgroundColor: "#f5f5f5", borderRadius: 2 }}>
      {/* Main Heading */}
      <Box sx={{ gap: "1rem", textAlign: "center" }}>
        <MotionTypography
          variant="h4"
          sx={{
            fontWeight: "bold",
            color: "#333",
            textShadow: "1px 1px 2px rgba(0,0,0,0.1)",
            textAlign: "center",
          }}
          initial={{ opacity: 0, scale: 0.5 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{
            duration: 0.8,
            delay: 0.5,
            ease: [0, 0.71, 0.2, 1.01],
          }}
        >
          About Us
        </MotionTypography>

        {/* Subheading */}
        <MotionTypography
          variant="h6"
          sx={{
            color: "#777",
            marginBottom: "1.5rem",
            textAlign: "center",
            maxWidth: "800px",
            margin: "0 auto",
            lineHeight: 1.5,
          }}
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{
            duration: 0.8,
            delay: 0.7,
            ease: [0.42, 0, 0.58, 1],
          }}
        >
          Welcome to our institution, where innovation meets education. Our
          mission is to provide quality education through expert instructors and
          modern facilities, ensuring students gain the knowledge they need to
          succeed.
        </MotionTypography>
      </Box>

      {/* Content Section */}
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          justifyContent: "space-around",
          gap: 4,
          p: { xs: 2, sm: 4 },
        }}
      >
        {/* Mission */}
        <Box
          sx={{
            backgroundColor: "white",
            boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
            borderRadius: "16px",
            p: 3,
            textAlign: "center",
          }}
        >
          <Typography variant="h6" sx={{ fontWeight: "bold", mb: 2 }}>
            Our Mission
          </Typography>
          <Typography variant="body1" sx={{ color: "#555" }}>
            Our mission is to foster an environment of learning that not only
            prepares students for academic success but also encourages personal
            and professional growth.
          </Typography>
        </Box>

        {/* Vision */}
        <Box
          sx={{
            backgroundColor: "white",
            boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
            borderRadius: "16px",
            p: 3,
            textAlign: "center",
          }}
        >
          <Typography variant="h6" sx={{ fontWeight: "bold", mb: 2 }}>
            Our Vision
          </Typography>
          <Typography variant="body1" sx={{ color: "#555" }}>
            To become a globally recognized institution where students can
            achieve their dreams through innovation and excellence in education.
          </Typography>
        </Box>

        {/* Values */}
        <Box
          sx={{
            backgroundColor: "white",
            boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
            borderRadius: "16px",
            p: 3,
            textAlign: "center",
          }}
        >
          <Typography variant="h6" sx={{ fontWeight: "bold", mb: 2 }}>
            Our Values
          </Typography>
          <Typography variant="body1" sx={{ color: "#555" }}>
            We value integrity, innovation, and dedication. These principles
            guide our approach to teaching and the relationships we build with
            our students.
          </Typography>
        </Box>
      </Box>

      {/* message from our founders */}

      <Box sx={{ gap: "1rem", mt: 2 }}>
        <MotionTypography
          variant="h4"
          sx={{
            fontWeight: "bold",
            color: "#333",
            textShadow: "2px 2px 6px rgba(0,0,0,0.1)",
            textAlign: "center",
            mb: 3,
          }}
          initial={{ opacity: 0, scale: 0.5 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{
            duration: 0.8,
            delay: 0.5,
            ease: [0, 0.71, 0.2, 1.01],
          }}
        >
          Message from Leadership Team
        </MotionTypography>

        <MotionTypography
          sx={{
            textAlign: "center",
            marginBottom: "2.5rem",
            color: "#444",
            maxWidth: "600px",
            mx: "auto",
            fontSize: "1.1rem",
          }}
        >
          Our mission is to empower students with knowledge through innovative
          educational solutions, nurturing their growth in today’s world.
        </MotionTypography>
      </Box>

      {/* Founder and Co-Founder Messages */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          flexDirection: { xs: "column", sm: "row" },
          gap: 3,
        }}
      >
        {/* Founder */}
        <Box
          sx={{
            background: "linear-gradient(145deg, #ffffff, #e6e6e6)",
            boxShadow:
              "8px 8px 16px rgba(0,0,0,0.1), -8px -8px 16px rgba(255,255,255,0.7)",
            borderRadius: "24px",
            p: 3,
            textAlign: "center",
            width: { xs: "100%", sm: "300px" },
            transition: "transform 0.4s ease, box-shadow 0.4s ease",
            "&:hover": {
              transform: "scale(1.05)",
              boxShadow:
                "10px 10px 20px rgba(0,0,0,0.2), -10px -10px 20px rgba(255,255,255,0.8)",
            },
          }}
        >
          <Avatar
            alt="Mahendra Vyas"
            src="https://avatar.vercel.sh/jack"
            sx={{
              width: 100,
              height: 100,
              margin: "0 auto",
              mb: 2,
              boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
              border: "4px solid white",
            }}
          />
          <Typography
            variant="h6"
            sx={{ fontWeight: "bold", color: "#333", mb: 1 }}
          >
            Mahendra Vyas
          </Typography>
          <Typography variant="body1" sx={{ color: "#666", mb: 2 }}>
            Founder
          </Typography>
          <Box sx={{ mb: 1 }}>
            <IconButton
              size="medium"
              color="black !important"
              href="https://www.facebook.com/aastha.computers.10"
              target="_blank"
              sx={{ color: "black !important" }}
            >
              <FacebookIcon />
            </IconButton>
            <IconButton
              size="medium"
              color="black"
              href="wa.me/9928004669"
              target="_blank"
              sx={{ color: "black !important" }}
            >
              <FaWhatsapp />
            </IconButton>
            <IconButton
              size="medium"
              color="black"
              href="https://www.instagram.com/aastha_computers/"
              target="_blank"
              sx={{ color: "black !important" }}
            >
              <Instagram />
            </IconButton>
            <IconButton
              size="medium"
              color="black"
              href="https://www.linkedin.com/company/aastha-computers/"
              target="_blank"
              sx={{ color: "black !important" }}
            >
              <LinkedInIcon />
            </IconButton>
          </Box>
          <Typography
            variant="body2"
            sx={{ color: "#555", fontStyle: "italic" }}
          >
            "We focus on fostering growth through education, ensuring every
            student is well-prepared for success."
          </Typography>
        </Box>

        {/* Co-Founder */}
        <Box
          sx={{
            background: "linear-gradient(145deg, #ffffff, #e6e6e6)",
            boxShadow:
              "8px 8px 16px rgba(0,0,0,0.1), -8px -8px 16px rgba(255,255,255,0.7)",
            borderRadius: "24px",
            p: 3,
            textAlign: "center",
            width: { xs: "100%", sm: "300px" },
            transition: "transform 0.4s ease, box-shadow 0.4s ease",
            "&:hover": {
              transform: "scale(1.05)",
              boxShadow:
                "10px 10px 20px rgba(0,0,0,0.2), -10px -10px 20px rgba(255,255,255,0.8)",
            },
          }}
        >
          <Avatar
            alt="Mukesh Raj Vyas"
            src="https://avatar.vercel.sh/jack"
            sx={{
              width: 100,
              height: 100,
              margin: "0 auto",
              mb: 2,
              boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
              border: "4px solid white",
            }}
          />
          <Typography
            variant="h6"
            sx={{ fontWeight: "bold", color: "#333", mb: 1 }}
          >
            Mukesh Raj Vyas
          </Typography>
          <Typography variant="body1" sx={{ color: "#666", mb: 2 }}>
            Co-Founder
          </Typography>
          <Box sx={{ mb: 1 }}>
            <IconButton
              size="medium"
              color="black !important"
              href="https://www.facebook.com/aastha.computers.10"
              target="_blank"
              sx={{ color: "black !important" }}
            >
              <FacebookIcon />
            </IconButton>
            <IconButton
              size="medium"
              color="black"
              href="wa.me/9928004669"
              target="_blank"
              sx={{ color: "black !important" }}
            >
              <FaWhatsapp />
            </IconButton>
            <IconButton
              size="medium"
              color="black"
              href="https://www.instagram.com/aastha_computers/"
              target="_blank"
              sx={{ color: "black !important" }}
            >
              <Instagram />
            </IconButton>
            <IconButton
              size="medium"
              color="black"
              href="https://www.linkedin.com/company/aastha-computers/"
              target="_blank"
              sx={{ color: "black !important" }}
            >
              <LinkedInIcon />
            </IconButton>
          </Box>
          <Typography
            variant="body2"
            sx={{ color: "#555", fontStyle: "italic" }}
          >
            "Our aim is to continuously innovate and improve our educational
            approaches for the best outcomes."
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}

export default AboutUs;
